import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.partner.index'),
        name: 'reseller.index',
        component: () =>
            import(
                /* webpackChunkName: "partners" */ '@/views/partners/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('partner.breadcrumbs.index'),
                    to: { name: 'reseller.index' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('partner.routes.create'),
        name: 'reseller.create',
        component: () =>
            import(
                /* webpackChunkName: "partners" */ '@/views/partners/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('partner.breadcrumbs.index'),
                    to: { name: 'reseller.index' },
                    disable: false,
                },
                {
                    text: i18n.t('partner.breadcrumbs.create'),
                    to: { name: 'reseller.create' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('partner.routes.show') + '/:id',
        name: 'reseller.show',
        component: () =>
            import(
                /* webpackChunkName: "partners" */ '@/views/partners/Show.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('partner.breadcrumbs.index'),
                    to: { name: 'reseller.index' },
                    disable: false,
                },
                {
                    text: i18n.t('partner.breadcrumbs.show'),
                    to: { name: 'reseller.show' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('partner.routes.edit') + '/:id',
        name: 'reseller.edit',
        component: () =>
            import(
                /* webpackChunkName: "partners" */ '@/views/partners/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('partner.breadcrumbs.index'),
                    to: { name: 'reseller.index' },
                    disable: false,
                },
                {
                    text: i18n.t('partner.breadcrumbs.edit'),
                    to: { name: 'reseller.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
